import { CLIENTS } from '../../../helpers/constants';

export const BASIC_USER_INFO = {
  [CLIENTS.CLEAROUT.NAME]: {
    RIGHT_TABLE: [
      {
        label: 'Email',
        accessorKey: 'email',
        formatter: 'emailFormatter',
      },
      {
        label: 'Phone',
        accessorKey: 'phone_number',
        formatter: 'phoneFormatter',
      },
      {
        label: 'TimeZone',
        accessorKey: 'locale.timezone',
        formatter: 'timezoneFormatter',
      },
      {
        label: 'Activated On',
        accessorKey: 'activated_on',
        formatter: 'activatedOnFormatter',
      },
      // {
      //   label: 'Id',
      //   accessorKey: 'org_id',
      //   formatter: 'orgIdFormatter',
      // },
      {
        label: 'Account Status',
        accessorKey: 'status',
        formatter: 'accountStatusFormatter',
      },
      {
        label: 'Member Status',
        accessorKey: 'account_status',
        formatter: 'memberStatusFormatter',
      },
      {
        label: 'Signup Type',
        // accessorKey: 'industry', this is additional userdata 
        formatter: 'signupFormatter',
      },
      {
        label: 'Role',
        accessorKey: 'user_role',
        formatter: 'UserRole',
      },
    ],
    OVERVIEW_SECTION: [
      {
        label: 'Remaining Credits',
        accessorKey: 'credits.total',
        formatter: 'totalRemainingCreditsFormatter',
      },
      {
        label: 'Low Credit Threshold',
        // accessorKey: 'credits.total',
        formatter: 'lowCreditThreshold',
      },
      {
        label: 'Next Credit Allocation Date',
        // accessorKey: 'next_allocation_date',
        formatter: 'nextCreditsAllocationDate',
      },
      {
        label: 'Plan',
        formatter: 'planFormatter',
      },
      {
        label: 'Billable',
        // accessorKey: 'credits.total',
        formatter: 'billableFormatter',
      },
      {
        label: 'Next Billing Date',
        formatter: 'nextBillingDate',
      },
      {
        label: 'Revenue(In $)',
        formatter: 'totalAmountPaidFormatter',
      },
      {
        label: 'Last Purchase Date',
        formatter: 'lastPurchasedOnFormatter',
      },
      {
        label: 'Total Payment Count',
        formatter: 'totalPaymentCountFormatter',
      },
    ],
    QUICK_ACTIONS: [
      {
        label: 'Radar',
        // accessorKey: 'status',
        formatter: 'radarFormatter',
      },
      {
        label: 'Credits',
        accessorKey: 'credits.total',
        formatter: 'remainingCreditsFormatter',
      },
    ]

  },
  [CLIENTS.CLEAROUTPHONE.NAME]: {
    LEFT_TABLE: [
      {
        label: 'Job Title',
        // accessorKey: 'job_title', this is additional userdata 
        formatter: 'jobTitleFormatter',
      },
      {
        label: 'Industry',
        // accessorKey: 'industry',  this is additional userdata 
        formatter: 'industryFormatter',
      },
      {
        label: 'Company Name',
        // accessorKey: 'industry',  this is additional userdata 
        formatter: 'companyNameFormatter',
      }
    ],
    RIGHT_TABLE: [
      {
        label: 'Email',
        accessorKey: 'email',
        formatter: 'emailFormatter',
      },
      {
        label: 'Phone',
        accessorKey: 'phone_number',
        formatter: 'phoneFormatter',
      },
      {
        label: 'TimeZone',
        accessorKey: 'locale.timezone',
        formatter: 'timezoneFormatter',
      },
      {
        label: 'Account Status',
        accessorKey: 'status',
        formatter: 'accountStatusFormatter',
      },
      {
        label: 'Member Status',
        accessorKey: 'account_status',
        formatter: 'memberStatusFormatter',
      },
      {
        label: 'Activated On',
        accessorKey: 'activated_on',
        formatter: 'activatedOnFormatter',
      },
      {
        label: 'Signup Type',
        // accessorKey: 'industry', this is additional userdata 
        formatter: 'signupFormatter',
      },
      {
        label: 'Role',
        accessorKey: 'user_role',
        formatter: 'UserRole',
      },
    ],
    OVERVIEW_SECTION: [
      {
        label: 'Remaining Credits',
        accessorKey: 'credits.total',
        formatter: 'totalRemainingCreditsFormatter',
      },
      {
        label: 'Low Credit Threshold',
        // accessorKey: 'credits.total',
        formatter: 'lowCreditThreshold',
      },
      {
        label: 'Next Credit Allocation Date',
        // accessorKey: 'next_allocation_date',
        formatter: 'nextCreditsAllocationDate',
      },
      {
        label: 'Plan',
        formatter: 'planFormatter',
      },
      {
        label: 'Billable',
        // accessorKey: 'credits.total',
        formatter: 'billableFormatter',
      },
      {
        label: 'Next Billing Date',
        formatter: 'nextBillingDate',
      },
      {
        label: 'Revenue(In $)',
        // accessorKey: 'tags[0].total',
        formatter: 'totalAmountPaidFormatter',
      },
      {
        label: 'Last Purchase Date',
        // accessorKey: 'tags[0].last_purchased_on',
        formatter: 'lastPurchasedOnFormatter',
      },
      {
        label: 'Total Payment Count',
        // accessorKey: 'tags[0].count',
        formatter: 'totalPaymentCountFormatter',
      },
    ],
    QUICK_ACTIONS: [
      {
        label: 'Radar',
        // accessorKey: 'status',
        formatter: 'radarFormatter',
      },
      {
        label: 'Credits',
        accessorKey: 'credits.total',
        formatter: 'remainingCreditsFormatter',
      },
    ]
  },
  [CLIENTS.EU_CLEAROUTPHONE.NAME]: {
    LEFT_TABLE: [
      {
        label: 'Job Title',
        // accessorKey: 'job_title', this is additional userdata 
        formatter: 'jobTitleFormatter',
      },
      {
        label: 'Industry',
        // accessorKey: 'industry',  this is additional userdata 
        formatter: 'industryFormatter',
      },
      {
        label: 'Company Name',
        // accessorKey: 'industry',  this is additional userdata 
        formatter: 'companyNameFormatter',
      }
    ],
    RIGHT_TABLE: [
      {
        label: 'Email',
        accessorKey: 'email',
        formatter: 'emailFormatter',
      },
      {
        label: 'Phone',
        accessorKey: 'phone_number',
        formatter: 'phoneFormatter',
      },
      {
        label: 'TimeZone',
        accessorKey: 'locale.timezone',
        formatter: 'timezoneFormatter',
      },
      {
        label: 'Account Status',
        accessorKey: 'status',
        formatter: 'accountStatusFormatter',
      },
      {
        label: 'Member Status',
        accessorKey: 'account_status',
        formatter: 'memberStatusFormatter',
      },
      {
        label: 'Activated On',
        accessorKey: 'activated_on',
        formatter: 'activatedOnFormatter',
      },
      {
        label: 'Signup Type',
        // accessorKey: 'industry', this is additional userdata 
        formatter: 'signupFormatter',
      },
      {
        label: 'Role',
        accessorKey: 'user_role',
        formatter: 'UserRole',
      },
    ],
    OVERVIEW_SECTION: [
      {
        label: 'Remaining Credits',
        accessorKey: 'credits.total',
        formatter: 'totalRemainingCreditsFormatter',
      },
      {
        label: 'Low Credit Threshold',
        // accessorKey: 'credits.total',
        formatter: 'lowCreditThreshold',
      },
      {
        label: 'Next Credit Allocation Date',
        // accessorKey: 'next_allocation_date',
        formatter: 'nextCreditsAllocationDate',
      },
      {
        label: 'Plan',
        formatter: 'planFormatter',
      },
      {
        label: 'Billable',
        // accessorKey: 'credits.total',
        formatter: 'billableFormatter',
      },
      {
        label: 'Next Billing Date',
        formatter: 'nextBillingDate',
      },
      {
        label: 'Revenue(In $)',
        // accessorKey: 'tags[0].total',
        formatter: 'totalAmountPaidFormatter',
      },
      {
        label: 'Last Purchase Date',
        // accessorKey: 'tags[0].last_purchased_on',
        formatter: 'lastPurchasedOnFormatter',
      },
      {
        label: 'Total Payment Count',
        // accessorKey: 'tags[0].count',
        formatter: 'totalPaymentCountFormatter',
      },
    ],
    QUICK_ACTIONS: [
      {
        label: 'Radar',
        // accessorKey: 'status',
        formatter: 'radarFormatter',
      },
      {
        label: 'Credits',
        accessorKey: 'credits.total',
        formatter: 'remainingCreditsFormatter',
      },
    ]
  },
  [CLIENTS.SPOKESLY_CLEAROUT.NAME]: {
    LEFT_TABLE: [
      {
        label: 'Job Title',
        // accessorKey: 'job_title', this is additional userdata 
        formatter: 'jobTitleFormatter',
      },
      {
        label: 'Industry',
        // accessorKey: 'industry',  this is additional userdata 
        formatter: 'industryFormatter',
      },
      {
        label: 'Company Name',
        // accessorKey: 'industry',  this is additional userdata 
        formatter: 'companyNameFormatter',
      }
    ],
    RIGHT_TABLE: [
      {
        label: 'Email',
        accessorKey: 'email',
        formatter: 'emailFormatter',
      },
      {
        label: 'Phone',
        accessorKey: 'phone_number',
        formatter: 'phoneFormatter',
      },
      {
        label: 'TimeZone',
        accessorKey: 'locale.timezone',
        formatter: 'timezoneFormatter',
      },
      {
        label: 'Activated On',
        accessorKey: 'activated_on',
        formatter: 'activatedOnFormatter',
      },
      // {
      //   label: 'Id',
      //   accessorKey: 'org_id',
      //   formatter: 'orgIdFormatter',
      // },
      {
        label: 'Account Status',
        accessorKey: 'status',
        formatter: 'accountStatusFormatter',
      },
      {
        label: 'Member Status',
        accessorKey: 'account_status',
        formatter: 'memberStatusFormatter',
      },
      {
        label: 'Signup Type',
        // accessorKey: 'industry', this is additional userdata 
        formatter: 'signupFormatter',
      },
      {
        label: 'Role',
        accessorKey: 'user_role',
        formatter: 'UserRole',
      },
    ],
    OVERVIEW_SECTION: [
      {
        label: 'Remaining Credits',
        accessorKey: 'credits.total',
        formatter: 'totalRemainingCreditsFormatter',
      },
      {
        label: 'Low Credit Threshold',
        // accessorKey: 'credits.total',
        formatter: 'lowCreditThreshold',
      },
      {
        label: 'Next Credit Allocation Date',
        // accessorKey: 'next_allocation_date',
        formatter: 'nextCreditsAllocationDate',
      },
      {
        label: 'Plan',
        formatter: 'planFormatter',
      },
      {
        label: 'Billable',
        // accessorKey: 'credits.total',
        formatter: 'billableFormatter',
      },
      {
        label: 'Next Billing Date',
        formatter: 'nextBillingDate',
      },
      {
        label: 'Revenue(In $)',
        formatter: 'totalAmountPaidFormatter',
      },
      {
        label: 'Last Purchase date',
        formatter: 'lastPurchasedOnFormatter',
      },
      {
        label: 'Total payment count',
        formatter: 'totalPaymentCountFormatter',
      },
    ],
    QUICK_ACTIONS: [
      {
        label: 'Credits',
        accessorKey: 'credits.total',
        formatter: 'remainingCreditsFormatter',
      },
    ]
  },
  [CLIENTS.EU_CLEAROUT.NAME]: {
    LEFT_TABLE: [
      {
        label: 'Job Title',
        // accessorKey: 'job_title', this is additional userdata 
        formatter: 'jobTitleFormatter',
      },
      {
        label: 'Industry',
        // accessorKey: 'industry',  this is additional userdata 
        formatter: 'industryFormatter',
      },
      {
        label: 'Company Name',
        // accessorKey: 'industry',  this is additional userdata 
        formatter: 'companyNameFormatter',
      }
    ],
    RIGHT_TABLE: [
      {
        label: 'Email',
        accessorKey: 'email',
        formatter: 'emailFormatter',
      },
      {
        label: 'Phone',
        accessorKey: 'phone_number',
        formatter: 'phoneFormatter',
      },
      {
        label: 'TimeZone',
        accessorKey: 'locale.timezone',
        formatter: 'timezoneFormatter',
      },
      {
        label: 'Activated On',
        accessorKey: 'activated_on',
        formatter: 'activatedOnFormatter',
      },
      // {
      //   label: 'Id',
      //   accessorKey: 'org_id',
      //   formatter: 'orgIdFormatter',
      // },
      {
        label: 'Account Status',
        accessorKey: 'status',
        formatter: 'accountStatusFormatter',
      },
      {
        label: 'Member Status',
        accessorKey: 'account_status',
        formatter: 'memberStatusFormatter',
      },
      {
        label: 'Signup Type',
        // accessorKey: 'industry', this is additional userdata 
        formatter: 'signupFormatter',
      },
      {
        label: 'Role',
        accessorKey: 'user_role',
        formatter: 'UserRole',
      },
    ],
    OVERVIEW_SECTION: [
      {
        label: 'Remaining Credits',
        accessorKey: 'credits.total',
        formatter: 'totalRemainingCreditsFormatter',
      },
      {
        label: 'Low Credit Threshold',
        // accessorKey: 'credits.total',
        formatter: 'lowCreditThreshold',
      },
      {
        label: 'Next Credit Allocation Date',
        // accessorKey: 'next_allocation_date',
        formatter: 'nextCreditsAllocationDate',
      },
      {
        label: 'Plan',
        formatter: 'planFormatter',
      },
      {
        label: 'Billable',
        // accessorKey: 'credits.total',
        formatter: 'billableFormatter',
      },
      {
        label: 'Next Billing Date',
        formatter: 'nextBillingDate',
      },
      {
        label: 'Revenue(In $)',
        formatter: 'totalAmountPaidFormatter',
      },
      {
        label: 'Last Purchase date',
        formatter: 'lastPurchasedOnFormatter',
      },
      {
        label: 'Total payment count',
        formatter: 'totalPaymentCountFormatter',
      },
    ],
    QUICK_ACTIONS: [
      {
        label: 'Credits',
        accessorKey: 'credits.total',
        formatter: 'remainingCreditsFormatter',
      },
    ]
  },
  [CLIENTS.CAMS_CLEAROUT.NAME]: {
    LEFT_TABLE: [
      {
        label: 'Job Title',
        // accessorKey: 'job_title', this is additional userdata 
        formatter: 'jobTitleFormatter',
      },
      {
        label: 'Industry',
        // accessorKey: 'industry',  this is additional userdata 
        formatter: 'industryFormatter',
      },
      {
        label: 'Company Name',
        // accessorKey: 'industry',  this is additional userdata 
        formatter: 'companyNameFormatter',
      }
    ],
    RIGHT_TABLE: [
      {
        label: 'Email',
        accessorKey: 'email',
        formatter: 'emailFormatter',
      },
      {
        label: 'Phone',
        accessorKey: 'phone_number',
        formatter: 'phoneFormatter',
      },
      {
        label: 'TimeZone',
        accessorKey: 'locale.timezone',
        formatter: 'timezoneFormatter',
      },
      {
        label: 'Activated On',
        accessorKey: 'activated_on',
        formatter: 'activatedOnFormatter',
      },
      // {
      //   label: 'Id',
      //   accessorKey: 'org_id',
      //   formatter: 'orgIdFormatter',
      // },
      {
        label: 'Account Status',
        accessorKey: 'status',
        formatter: 'accountStatusFormatter',
      },
      {
        label: 'Member Status',
        accessorKey: 'account_status',
        formatter: 'memberStatusFormatter',
      },
      {
        label: 'Signup Type',
        // accessorKey: 'industry', this is additional userdata 
        formatter: 'signupFormatter',
      },
      {
        label: 'Role',
        accessorKey: 'user_role',
        formatter: 'UserRole',
      },
    ],
    OVERVIEW_SECTION: [
      {
        label: 'Remaining Credits',
        accessorKey: 'credits.total',
        formatter: 'totalRemainingCreditsFormatter',
      },
      {
        label: 'Low Credit Threshold',
        // accessorKey: 'credits.total',
        formatter: 'lowCreditThreshold',
      },
      {
        label: 'Next Credit Allocation Date',
        // accessorKey: 'next_allocation_date',
        formatter: 'nextCreditsAllocationDate',
      },
      {
        label: 'Plan',
        formatter: 'planFormatter',
      },
      {
        label: 'Billable',
        // accessorKey: 'credits.total',
        formatter: 'billableFormatter',
      },
      {
        label: 'Next Billing Date',
        formatter: 'nextBillingDate',
      },
      {
        label: 'Revenue(In $)',
        formatter: 'totalAmountPaidFormatter',
      },
      {
        label: 'Last Purchase date',
        formatter: 'lastPurchasedOnFormatter',
      },
      {
        label: 'Total payment count',
        formatter: 'totalPaymentCountFormatter',
      },
    ],
    QUICK_ACTIONS: [
      {
        label: 'Credits',
        accessorKey: 'credits.total',
        formatter: 'remainingCreditsFormatter',
      },
    ]
  },
  [CLIENTS.PEPIPOST_CLEAROUT.NAME]: {
    LEFT_TABLE: [
      {
        label: 'Job Title',
        // accessorKey: 'job_title', this is additional userdata 
        formatter: 'jobTitleFormatter',
      },
      {
        label: 'Industry',
        // accessorKey: 'industry',  this is additional userdata 
        formatter: 'industryFormatter',
      },
      {
        label: 'Company Name',
        // accessorKey: 'industry',  this is additional userdata 
        formatter: 'companyNameFormatter',
      }
    ],
    RIGHT_TABLE: [
      {
        label: 'Email',
        accessorKey: 'email',
        formatter: 'emailFormatter',
      },
      {
        label: 'Phone',
        accessorKey: 'phone_number',
        formatter: 'phoneFormatter',
      },
      {
        label: 'TimeZone',
        accessorKey: 'locale.timezone',
        formatter: 'timezoneFormatter',
      },
      {
        label: 'Activated On',
        accessorKey: 'activated_on',
        formatter: 'activatedOnFormatter',
      },
      // {
      //   label: 'Id',
      //   accessorKey: 'org_id',
      //   formatter: 'orgIdFormatter',
      // },
      {
        label: 'Account Status',
        accessorKey: 'status',
        formatter: 'accountStatusFormatter',
      },
      {
        label: 'Member Status',
        accessorKey: 'account_status',
        formatter: 'memberStatusFormatter',
      },
      {
        label: 'Signup Type',
        // accessorKey: 'industry', this is additional userdata 
        formatter: 'signupFormatter',
      },
      {
        label: 'Role',
        accessorKey: 'user_role',
        formatter: 'UserRole',
      },
    ],
    OVERVIEW_SECTION: [
      {
        label: 'Remaining Credits',
        accessorKey: 'credits.total',
        formatter: 'totalRemainingCreditsFormatter',
      },
      {
        label: 'Low Credit Threshold',
        // accessorKey: 'credits.total',
        formatter: 'lowCreditThreshold',
      },
      {
        label: 'Next Credit Allocation Date',
        // accessorKey: 'next_allocation_date',
        formatter: 'nextCreditsAllocationDate',
      },
      {
        label: 'Plan',
        formatter: 'planFormatter',
      },
      {
        label: 'Billable',
        // accessorKey: 'credits.total',
        formatter: 'billableFormatter',
      },
      {
        label: 'Next Billing Date',
        formatter: 'nextBillingDate',
      },
      {
        label: 'Revenue(In $)',
        formatter: 'totalAmountPaidFormatter',
      },
      {
        label: 'Last Purchase date',
        formatter: 'lastPurchasedOnFormatter',
      },
      {
        label: 'Total payment count',
        formatter: 'totalPaymentCountFormatter',
      },
    ],
    QUICK_ACTIONS: [
      {
        label: 'Credits',
        accessorKey: 'credits.total',
        formatter: 'remainingCreditsFormatter',
      },
    ]
  },
  [CLIENTS.US_CLEAROUT.NAME]: {
    LEFT_TABLE: [
      {
        label: 'Job Title',
        // accessorKey: 'job_title', this is additional userdata 
        formatter: 'jobTitleFormatter',
      },
      {
        label: 'Industry',
        // accessorKey: 'industry',  this is additional userdata 
        formatter: 'industryFormatter',
      },
      {
        label: 'Company Name',
        // accessorKey: 'industry',  this is additional userdata 
        formatter: 'companyNameFormatter',
      }
    ],
    RIGHT_TABLE: [
      {
        label: 'Email',
        accessorKey: 'email',
        formatter: 'emailFormatter',
      },
      {
        label: 'Phone',
        accessorKey: 'phone_number',
        formatter: 'phoneFormatter',
      },
      {
        label: 'TimeZone',
        accessorKey: 'locale.timezone',
        formatter: 'timezoneFormatter',
      },
      {
        label: 'Activated On',
        accessorKey: 'activated_on',
        formatter: 'activatedOnFormatter',
      },
      // {
      //   label: 'Id',
      //   accessorKey: 'org_id',
      //   formatter: 'orgIdFormatter',
      // },
      {
        label: 'Account Status',
        accessorKey: 'status',
        formatter: 'accountStatusFormatter',
      },
      {
        label: 'Member Status',
        accessorKey: 'account_status',
        formatter: 'memberStatusFormatter',
      },
      {
        label: 'Signup Type',
        // accessorKey: 'industry', this is additional userdata 
        formatter: 'signupFormatter',
      },
      {
        label: 'Role',
        accessorKey: 'user_role',
        formatter: 'UserRole',
      },
    ],
    OVERVIEW_SECTION: [
      {
        label: 'Remaining Credits',
        accessorKey: 'credits.total',
        formatter: 'totalRemainingCreditsFormatter',
      },
      {
        label: 'Low Credit Threshold',
        // accessorKey: 'credits.total',
        formatter: 'lowCreditThreshold',
      },
      {
        label: 'Next Credit Allocation Date',
        // accessorKey: 'next_allocation_date',
        formatter: 'nextCreditsAllocationDate',
      },
      {
        label: 'Plan',
        formatter: 'planFormatter',
      },
      {
        label: 'Billable',
        // accessorKey: 'credits.total',
        formatter: 'billableFormatter',
      },
      {
        label: 'Next Billing Date',
        formatter: 'nextBillingDate',
      },
      {
        label: 'Revenue(In $)',
        formatter: 'totalAmountPaidFormatter',
      },
      {
        label: 'Last Purchase date',
        formatter: 'lastPurchasedOnFormatter',
      },
      {
        label: 'Total payment count',
        formatter: 'totalPaymentCountFormatter',
      },
    ],
    QUICK_ACTIONS: [
      {
        label: 'Credits',
        accessorKey: 'credits.total',
        formatter: 'remainingCreditsFormatter',
      },
    ]
  },
};

export const ACTION_BUTTONS = {
  [CLIENTS.CLEAROUT.NAME]: [
    'logout_sessions',
    'block_user',
    'unblock_user',
    'delete_user',
    'signup_link',
    'forgot_password_link',
    'payment_settings',
    'default_payment_account'
  ],
  [CLIENTS.CLEAROUTPHONE.NAME]: [
    'logout_sessions',
    'block_user',
    'unblock_user',
    'signup_link',
    'forgot_password_link',
    'payment_settings',
    'default_payment_account',
    'cop_view_stats',
    'delete_user'
  ],
  [CLIENTS.EU_CLEAROUTPHONE.NAME]: [
    'logout_sessions',
    'block_user',
    'unblock_user',
    'signup_link',
    'forgot_password_link',
    'payment_settings',
    'default_payment_account',
    'cop_view_stats',
    'delete_user'
  ],
  [CLIENTS.SPOKESLY_CLEAROUT.NAME]: [
    'logout_sessions',
    'block_user',
    'unblock_user',
    'signup_link',
    'forgot_password_link',
    'delete_user'
  ],
  [CLIENTS.EU_CLEAROUT.NAME]: [
    'logout_sessions',
    'block_user',
    'unblock_user',
    'signup_link',
    'forgot_password_link',
    'delete_user'
  ],
  [CLIENTS.PEPIPOST_CLEAROUT.NAME]: [
    'logout_sessions',
    'block_user',
    'unblock_user',
    'signup_link',
    'forgot_password_link',
    'delete_user'
  ],
  [CLIENTS.CAMS_CLEAROUT.NAME]: [
    'logout_sessions',
    'block_user',
    'unblock_user',
    'signup_link',
    'forgot_password_link',
    'delete_user'
  ],
  [CLIENTS.US_CLEAROUT.NAME]: [
    'logout_sessions',
    'block_user',
    'unblock_user',
    'signup_link',
    'forgot_password_link',
    'delete_user'
  ]
}

export const QUICK_LINKS = {
  [CLIENTS.CLEAROUT.NAME]: ['user_activities', 'matomo_activities', 'email_verifier_lists', 'email_finder_lists', 'prospect_lists'],
  [CLIENTS.CLEAROUTPHONE.NAME]: ['user_activities', 'matomo_activities', 'clearout_phone_lists'],
  [CLIENTS.EU_CLEAROUTPHONE.NAME]: ['user_activities', 'matomo_activities', 'clearout_phone_lists'],
  [CLIENTS.SPOKESLY_CLEAROUT.NAME]: ['user_activities', 'matomo_activities', 'email_verifier_lists', 'email_finder_lists', 'prospect_lists'],
  [CLIENTS.EU_CLEAROUT.NAME]: ['user_activities', 'matomo_activities', 'email_verifier_lists', 'email_finder_lists', 'prospect_lists'],
  [CLIENTS.PEPIPOST_CLEAROUT.NAME]: ['user_activities', 'matomo_activities', 'email_verifier_lists', 'email_finder_lists', 'prospect_lists'],
  [CLIENTS.CAMS_CLEAROUT.NAME]: ['user_activities', 'matomo_activities', 'email_verifier_lists', 'email_finder_lists', 'prospect_lists'],
  [CLIENTS.US_CLEAROUT.NAME]: ['user_activities', 'matomo_activities', 'email_verifier_lists', 'email_finder_lists', 'prospect_lists'],
}

export const TAB_KEY_AND_LABLE_MAPPING = {
  credits_limits: { key: 'credits_limits', label: 'Credits & Limits' },
  plans: { key: 'plans', label: 'Plans' },
  subscription_history: { key: 'subscription_history', label: 'Purchases' },
  invoices_receipts: { key: 'invoices_receipts', label: 'Billing' },
  analytics: { key: 'analytics', label: 'Analytics' },
  user_activities: { key: 'user_activities', label: 'Activities' },
}

export const TAB_SECTION = {
  [CLIENTS.CLEAROUT.NAME]: ['credits_limits', 'subscription_history', 'invoices_receipts', 'analytics', 'user_activities', 'plans'],
  [CLIENTS.CLEAROUTPHONE.NAME]: ['credits_limits', 'subscription_history', 'invoices_receipts', 'user_activities', 'plans'],
  [CLIENTS.EU_CLEAROUTPHONE.NAME]: ['credits_limits', 'subscription_history', 'invoices_receipts', 'user_activities', 'plans'],
  [CLIENTS.SPOKESLY_CLEAROUT.NAME]: ['credits_limits', 'subscription_history', 'invoices_receipts', 'analytics', 'user_activities', 'plans'],
  [CLIENTS.EU_CLEAROUT.NAME]: ['credits_limits', 'subscription_history', 'invoices_receipts', 'analytics', 'user_activities', 'plans'],
  [CLIENTS.PEPIPOST_CLEAROUT.NAME]: ['credits_limits', 'subscription_history', 'invoices_receipts', 'analytics', 'user_activities', 'plans'],
  [CLIENTS.CAMS_CLEAROUT.NAME]: ['credits_limits', 'subscription_history', 'invoices_receipts', 'analytics', 'user_activities', 'plans'],
  [CLIENTS.US_CLEAROUT.NAME]: ['credits_limits', 'subscription_history', 'invoices_receipts', 'analytics', 'user_activities', 'plans'],
}

export const BASIC_INFO = {
  [CLIENTS.CLEAROUT.NAME]: {
    SHOW_BUTTONS: ['edit_email'],
  },
  [CLIENTS.CLEAROUTPHONE.NAME]: {
    SHOW_BUTTONS: ['edit_email'],
  },
  [CLIENTS.EU_CLEAROUTPHONE.NAME]: {
    SHOW_BUTTONS: ['edit_email'],
  },
  [CLIENTS.SPOKESLY_CLEAROUT.NAME]: {
    SHOW_BUTTONS: ['edit_email'],
  },
  [CLIENTS.EU_CLEAROUT.NAME]: {
    SHOW_BUTTONS: ['edit_email'],
  },
  [CLIENTS.PEPIPOST_CLEAROUT.NAME]: {
    SHOW_BUTTONS: ['edit_email'],
  },
  [CLIENTS.CAMS_CLEAROUT.NAME]: {
    SHOW_BUTTONS: ['edit_email'],
  },
  [CLIENTS.US_CLEAROUT.NAME]: {
    SHOW_BUTTONS: ['edit_email'],
  },
}

export const EXTRA_USER_INFO = {
  [CLIENTS.CLEAROUT.NAME]: [
    {
      label: 'Member Status',
      accessorKey: 'account_status',
      formatter: 'memberStatusFormatter',
    },
    {
      label: 'Account Status',
      accessorKey: 'status',
      formatter: 'accountStatusFormatter',
    },
    {
      label: 'Signup Type',
      // accessorKey: 'industry', this is additional userdata 
      formatter: 'signupFormatter',
    },
    {
      label: 'Activated On',
      accessorKey: 'activated_on',
      formatter: 'activatedOnFormatter',
    },
    {
      label: 'Id',
      accessorKey: 'user_id',
      formatter: 'userIdFormatter',
    },
    {
      label: 'Org Id',
      accessorKey: 'org_id',
      formatter: 'orgIdFormatter',
    },
    {
      label: 'Use Radar',
      // accessorKey: 'status',
      formatter: 'radarFormatter',
    },
    {
      label: 'Remaining Credits',
      accessorKey: 'credits.total',
      formatter: 'remainingCreditsFormatter',
    },
    {
      label: 'Total Amount Paid (In $)',
      // accessorKey: 'tags[0].total',
      formatter: 'totalAmountPaidFormatter',
    },
    {
      label: 'Last Purchased On',
      // accessorKey: 'tags[0].last_purchased_on',
      formatter: 'lastPurchasedOnFormatter',
    },
    {
      label: 'Total Payment Count',
      // accessorKey: 'tags[0].count',
      formatter: 'totalPaymentCountFormatter',
    },

  ],
  [CLIENTS.CLEAROUTPHONE.NAME]: [
    {
      label: 'Member Status',
      accessorKey: 'account_status',
      formatter: 'memberStatusFormatter',
    },
    {
      label: 'Account Status',
      accessorKey: 'status',
      formatter: 'accountStatusFormatter',
    },
    {
      label: 'Activated On',
      accessorKey: 'activated_on',
      formatter: 'activatedOnFormatter',
    },
    {
      label: 'Id',
      accessorKey: 'user_id',
      formatter: 'userIdFormatter',
    },
    // {
    //   label: 'Org Id',
    //   accessorKey: 'org_id',
    //   formatter: 'orgIdFormatter',
    // },
    {
      label: 'Remaining Credits',
      accessorKey: 'credits.total',
      formatter: 'remainingCreditsFormatter',
    },
    {
      label: 'Total Amount Paid (In $)',
      accessorKey: 'tags[0].total',
      formatter: 'copTotalAmountPaidFormatter',
    },
    {
      label: 'Last Purchased On',
      accessorKey: 'tags[0].last_purchased_on',
      formatter: 'copLastPurchasedOnFormatter',
    },
    {
      label: 'Total Payment Count',
      accessorKey: 'tags[0].count',
      formatter: 'copTotalPaymentCountFormatter',
    },


  ],
  [CLIENTS.EU_CLEAROUTPHONE.NAME]: [
    {
      label: 'Member Status',
      accessorKey: 'account_status',
      formatter: 'memberStatusFormatter',
    },
    {
      label: 'Account Status',
      accessorKey: 'status',
      formatter: 'accountStatusFormatter',
    },
    {
      label: 'Activated On',
      accessorKey: 'activated_on',
      formatter: 'activatedOnFormatter',
    },
    {
      label: 'Id',
      accessorKey: 'user_id',
      formatter: 'userIdFormatter',
    },
    // {
    //   label: 'Org Id',
    //   accessorKey: 'org_id',
    //   formatter: 'orgIdFormatter',
    // },
    {
      label: 'Remaining Credits',
      accessorKey: 'credits.total',
      formatter: 'remainingCreditsFormatter',
    },
    {
      label: 'Total Amount Paid (In $)',
      accessorKey: 'tags[0].total',
      formatter: 'copTotalAmountPaidFormatter',
    },
    {
      label: 'Last Purchased On',
      accessorKey: 'tags[0].last_purchased_on',
      formatter: 'copLastPurchasedOnFormatter',
    },
    {
      label: 'Total Payment Count',
      accessorKey: 'tags[0].count',
      formatter: 'copTotalPaymentCountFormatter',
    },


  ],
  [CLIENTS.SPOKESLY_CLEAROUT.NAME]: [
    {
      label: 'Member Status',
      accessorKey: 'account_status',
      formatter: 'memberStatusFormatter',
    },
    {
      label: 'Account Status',
      accessorKey: 'status',
      formatter: 'accountStatusFormatter',
    },
    {
      label: 'Activated On',
      accessorKey: 'activated_on',
      formatter: 'activatedOnFormatter',
    },
    {
      label: 'Id',
      accessorKey: 'user_id',
      formatter: 'userIdFormatter',
    },
    // {
    //   label: 'Org Id',
    //   accessorKey: 'org_id',
    //   formatter: 'orgIdFormatter',
    // },
    {
      label: 'Remaining Credits',
      accessorKey: 'credits.total',
      formatter: 'remainingCreditsFormatter',
    },
    {
      label: 'Total Amount Paid (In $)',
      accessorKey: 'tags[0].total',
      formatter: 'copTotalAmountPaidFormatter',
    },
    {
      label: 'Last Purchased On',
      accessorKey: 'tags[0].last_purchased_on',
      formatter: 'copLastPurchasedOnFormatter',
    },
    {
      label: 'Total Payment Count',
      accessorKey: 'tags[0].count',
      formatter: 'copTotalPaymentCountFormatter',
    },


  ],
  [CLIENTS.EU_CLEAROUT.NAME]: [
    {
      label: 'Member Status',
      accessorKey: 'account_status',
      formatter: 'memberStatusFormatter',
    },
    {
      label: 'Account Status',
      accessorKey: 'status',
      formatter: 'accountStatusFormatter',
    },
    {
      label: 'Activated On',
      accessorKey: 'activated_on',
      formatter: 'activatedOnFormatter',
    },
    {
      label: 'Id',
      accessorKey: 'user_id',
      formatter: 'userIdFormatter',
    },
    // {
    //   label: 'Org Id',
    //   accessorKey: 'org_id',
    //   formatter: 'orgIdFormatter',
    // },
    {
      label: 'Remaining Credits',
      accessorKey: 'credits.total',
      formatter: 'remainingCreditsFormatter',
    },
    {
      label: 'Total Amount Paid (In $)',
      accessorKey: 'tags[0].total',
      formatter: 'copTotalAmountPaidFormatter',
    },
    {
      label: 'Last Purchased On',
      accessorKey: 'tags[0].last_purchased_on',
      formatter: 'copLastPurchasedOnFormatter',
    },
    {
      label: 'Total Payment Count',
      accessorKey: 'tags[0].count',
      formatter: 'copTotalPaymentCountFormatter',
    },
  ],
  [CLIENTS.PEPIPOST_CLEAROUT.NAME]: [
    {
      label: 'Member Status',
      accessorKey: 'account_status',
      formatter: 'memberStatusFormatter',
    },
    {
      label: 'Account Status',
      accessorKey: 'status',
      formatter: 'accountStatusFormatter',
    },
    {
      label: 'Activated On',
      accessorKey: 'activated_on',
      formatter: 'activatedOnFormatter',
    },
    {
      label: 'Id',
      accessorKey: 'user_id',
      formatter: 'userIdFormatter',
    },
    // {
    //   label: 'Org Id',
    //   accessorKey: 'org_id',
    //   formatter: 'orgIdFormatter',
    // },
    {
      label: 'Remaining Credits',
      accessorKey: 'credits.total',
      formatter: 'remainingCreditsFormatter',
    },
    {
      label: 'Total Amount Paid (In $)',
      accessorKey: 'tags[0].total',
      formatter: 'copTotalAmountPaidFormatter',
    },
    {
      label: 'Last Purchased On',
      accessorKey: 'tags[0].last_purchased_on',
      formatter: 'copLastPurchasedOnFormatter',
    },
    {
      label: 'Total Payment Count',
      accessorKey: 'tags[0].count',
      formatter: 'copTotalPaymentCountFormatter',
    },


  ],
  [CLIENTS.CAMS_CLEAROUT.NAME]: [
    {
      label: 'Member Status',
      accessorKey: 'account_status',
      formatter: 'memberStatusFormatter',
    },
    {
      label: 'Account Status',
      accessorKey: 'status',
      formatter: 'accountStatusFormatter',
    },
    {
      label: 'Activated On',
      accessorKey: 'activated_on',
      formatter: 'activatedOnFormatter',
    },
    {
      label: 'Id',
      accessorKey: 'user_id',
      formatter: 'userIdFormatter',
    },
    // {
    //   label: 'Org Id',
    //   accessorKey: 'org_id',
    //   formatter: 'orgIdFormatter',
    // },
    {
      label: 'Remaining Credits',
      accessorKey: 'credits.total',
      formatter: 'remainingCreditsFormatter',
    },
    {
      label: 'Total Amount Paid (In $)',
      accessorKey: 'tags[0].total',
      formatter: 'copTotalAmountPaidFormatter',
    },
    {
      label: 'Last Purchased On',
      accessorKey: 'tags[0].last_purchased_on',
      formatter: 'copLastPurchasedOnFormatter',
    },
    {
      label: 'Total Payment Count',
      accessorKey: 'tags[0].count',
      formatter: 'copTotalPaymentCountFormatter',
    },


  ],
  [CLIENTS.US_CLEAROUT.NAME]: [
    {
      label: 'Member Status',
      accessorKey: 'account_status',
      formatter: 'memberStatusFormatter',
    },
    {
      label: 'Account Status',
      accessorKey: 'status',
      formatter: 'accountStatusFormatter',
    },
    {
      label: 'Activated On',
      accessorKey: 'activated_on',
      formatter: 'activatedOnFormatter',
    },
    {
      label: 'Id',
      accessorKey: 'user_id',
      formatter: 'userIdFormatter',
    },
    // {
    //   label: 'Org Id',
    //   accessorKey: 'org_id',
    //   formatter: 'orgIdFormatter',
    // },
    {
      label: 'Remaining Credits',
      accessorKey: 'credits.total',
      formatter: 'remainingCreditsFormatter',
    },
    {
      label: 'Total Amount Paid (In $)',
      accessorKey: 'tags[0].total',
      formatter: 'copTotalAmountPaidFormatter',
    },
    {
      label: 'Last Purchased On',
      accessorKey: 'tags[0].last_purchased_on',
      formatter: 'copLastPurchasedOnFormatter',
    },
    {
      label: 'Total Payment Count',
      accessorKey: 'tags[0].count',
      formatter: 'copTotalPaymentCountFormatter',
    },
  ],
}

export const PAYMENT_ACCOUNTS = {
  [CLIENTS.CLEAROUT.NAME]: {
    PAYPAL: [
      { label: 'PayPal IND', value: 'paypal::india' },
      { label: 'PayPal US', value: 'paypal::us' },
    ],
    STRIPE: [
      { label: 'Stripe IND', value: 'stripe::india' },
      { label: 'Stripe US', value: 'stripe::us' },
    ],
  },
  [CLIENTS.CLEAROUTPHONE.NAME]: {
    PAYPAL: [
      { label: 'PayPal IND', value: 'paypal::india' },
      { label: 'PayPal US', value: 'paypal::us' },
    ],
    STRIPE: [
      { label: 'Stripe US', value: 'stripe::us' },
    ],
  },
  [CLIENTS.EU_CLEAROUTPHONE.NAME]: {
    PAYPAL: [
      { label: 'PayPal IND', value: 'paypal::india' },
      { label: 'PayPal US', value: 'paypal::us' },
    ],
    STRIPE: [
      { label: 'Stripe US', value: 'stripe::us' },
    ],
  },
  [CLIENTS.SPOKESLY_CLEAROUT.NAME]: {
    PAYPAL: [
      { label: 'PayPal IND', value: 'paypal::india' },
      { label: 'PayPal US', value: 'paypal::us' },
    ],
    STRIPE: [
      { label: 'Stripe IND', value: 'stripe::india' },
      { label: 'Stripe US', value: 'stripe::us' },
    ],
  },
  [CLIENTS.EU_CLEAROUT.NAME]: {
    PAYPAL: [
      { label: 'PayPal IND', value: 'paypal::india' },
      { label: 'PayPal US', value: 'paypal::us' },
    ],
    STRIPE: [
      { label: 'Stripe IND', value: 'stripe::india' },
      { label: 'Stripe US', value: 'stripe::us' },
    ],
  },
  [CLIENTS.PEPIPOST_CLEAROUT.NAME]: {
    PAYPAL: [
      { label: 'PayPal IND', value: 'paypal::india' },
      { label: 'PayPal US', value: 'paypal::us' },
    ],
    STRIPE: [
      { label: 'Stripe IND', value: 'stripe::india' },
      { label: 'Stripe US', value: 'stripe::us' },
    ],
  },
  [CLIENTS.CAMS_CLEAROUT.NAME]: {
    PAYPAL: [
      { label: 'PayPal IND', value: 'paypal::india' },
      { label: 'PayPal US', value: 'paypal::us' },
    ],
    STRIPE: [
      { label: 'Stripe IND', value: 'stripe::india' },
      { label: 'Stripe US', value: 'stripe::us' },
    ],
  },
  [CLIENTS.US_CLEAROUT.NAME]: {
    PAYPAL: [
      { label: 'PayPal IND', value: 'paypal::india' },
      { label: 'PayPal US', value: 'paypal::us' },
    ],
    STRIPE: [
      { label: 'Stripe IND', value: 'stripe::india' },
      { label: 'Stripe US', value: 'stripe::us' },
    ],
  },
}